module.exports = require('./helpers/bundle-url').getBundleURL('hg7Qi') + "macha.3ad5a73a.webp";